/*
 * SiaLinda: Absicherung des Warenkorb-Kommentars.
 *
 * Problem: Das Notizfeld wird vom Theme erst beim Absenden des Warenkorb-
 * Formulars gespeichert. Da der Warenkorb per AJAX neu geladen wird
 * (cart_ajax), geht ein getippter Text bei jeder Mengenaenderung verloren.
 * Express-Checkout-Buttons senden das Formular ueberhaupt nicht ab.
 *
 * Loesung: Der Text wird direkt in das Warenkorb-Objekt geschrieben, sobald
 * der Kunde ihn tippt. Damit haengt er am Warenkorb statt am Formular und
 * ueberlebt AJAX, Kasse-Button, Wallet-Buttons und Seitenwechsel.
 */
(function () {
  'use strict';

  if (window.slCartNoteInit) { return; }
  window.slCartNoteInit = true;

  var SELECTOR = '#CartSpecialInstructions, #MiniCartSpecialInstructions';
  var DELAY = 700;
  var lastSaved = null;
  var timer = null;

  function field() {
    return document.querySelector(SELECTOR);
  }

  function isNoteField(el) {
    return el && typeof el.matches === 'function' && el.matches(SELECTOR);
  }

  function save(value) {
    if (value === lastSaved) { return; }
    lastSaved = value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: value })
    }).catch(function () {
      lastSaved = null;
    });
  }

  function saveOnLeave() {
    var el = field();
    if (!el || el.value === lastSaved) { return; }
    lastSaved = el.value;
    try {
      var blob = new Blob([JSON.stringify({ note: el.value })], { type: 'application/json' });
      navigator.sendBeacon('/cart/update.js', blob);
    } catch (e) {
      lastSaved = null;
    }
  }

  function init() {
    var el = field();
    if (el) { lastSaved = el.value; }
  }

  document.addEventListener('input', function (e) {
    if (!isNoteField(e.target)) { return; }
    var value = e.target.value;
    clearTimeout(timer);
    timer = setTimeout(function () { save(value); }, DELAY);
  });

  document.addEventListener('blur', function (e) {
    if (!isNoteField(e.target)) { return; }
    clearTimeout(timer);
    save(e.target.value);
  }, true);

  window.addEventListener('pagehide', saveOnLeave);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { saveOnLeave(); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
